<template>
  <router-view></router-view>
</template>

<script>
import SessionStorage from '@/services/session-storage'

export default {
  name: 'app',
  beforeCreate () {
    if (this.$route.name !== 'Redirect') {
      let singleAcess = SessionStorage.get('singleAcess')
      if (singleAcess === 'true') {
        sessionStorage.clear()
        this.$router.push('/login')
      }
    }
  },
  watch: {
    $route (to, from) {
      if (from.name !== 'Redirect') {
        let singleAcess = SessionStorage.get('singleAcess')
        if (singleAcess === 'true') {
          sessionStorage.clear()
          this.$router.push('/login')
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue